import api from "./Api";

class ReceberService {
  GetReceber(payload) {
    return api.get("/v1/receber/" + payload).then((response) => {
      return response.data;
    });
  }

  PostReceber(payload) {
    return api.post("/v1/receber/", payload).then((response) => {
      return response.data;
    });
  }

  PutReceber(payload) {
    return api.put("/v1/receber/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteReceber(payload) {
    return api.delete("/v1/receber/" + payload).then((response) => {
      return response.data;
    });
  }

  GetReceberOData(payload) {
    return api.get("/OData/Receber" + payload).then((response) => {
      return response.data;
    });
  }

  Validate(payload) {
    return api.post("/v1/Receber/Validate/", payload).then((response) => {
      return response.data;
    });
  }

  Converter(payload) {
    return api.post("/v1/Receber/Converter/", payload).then((response) => {
      return response.data;
    });
  }

  Estornar(payload) {
    return api
      .get("/v1/Receber/Estornar?guid_transacao=" + payload)
      .then((response) => {
        return response.data;
      });
  }

  ReceberRegistros(payload) {
    return api
      .post("/v1/Receber/ReceberRegistros/", payload)
      .then((response) => {
        return response.data;
      });
  }

  ReplicarRegistros(payload) {
    return api
      .post("/v1/Receber/ReplicarRegistros/", payload)
      .then((response) => {
        return response.data;
      });
  }

  RenegociarRegistros(payload) {
    return api
      .post("/v1/Receber/RenegociarRegistros/", payload)
      .then((response) => {
        return response.data;
      });
  }

  ImprimirRecibo(payload) {
    return api
      .post("/v1/Receber/ImprimirRecibo/", payload, {
        responseType: "blob",
      })
      .then((response) => {
        return response;
      });
  }

  GetRelatorio(payload) {
    return api.post("/v1/Receber/GetRelatorio", payload).then((response) => {
      return response.data;
    });
  }

  PostGerarBoletoAsaas(payload) {
    return api
      .post("/v1/receber/GerarBoletoAsaas/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  PostGerarBoletoBanco(payload) {
    return api
      .post("/v1/receber/GerarBoletoBanco/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  PostGerarPIXAsaas(payload) {
    return api.post("/v1/receber/GerarPIXAsaas/" + payload).then((response) => {
      return response.data;
    });
  }

  PostBaixarBoletoAsaas(payload) {
    return api
      .post("/v1/receber/BaixarBoletoAsaas/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  PostBaixarBoletoBanco(payload) {
    const id = typeof payload === "object" ? payload.id : payload;
    const body = typeof payload === "object" ? payload : null;
    const rota =
      typeof payload === "object"
        ? "/v1/receber/BaixarBoletoBancoManual/"
        : "/v1/receber/BaixarBoletoBanco/";

    return api.post(rota + id, body).then((response) => {
      return response.data;
    });
  }

  PostGerarCardAsaas(payload) {
    return api
      .post("/v1/receber/GerarCardAsaas/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  PostMovimentacaoAsaas(payload) {
    return api
      .post("/v1/receber/MovimentacaoAsaas" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetImprimirBoletoBanco(payload) {
    return api.get("/v1/BoletoReceber/Pdf/" + payload, {
      responseType: "blob",
    });
  }
}

export default new ReceberService();
